module.exports = __webpack_public_path__ + "static/media/Rectangle87.d71bd206.png";